module.exports = __webpack_public_path__ + "img/svg/button-modal.f8b29cda950b7f1f1f5f8b49aabbc2ab.svg";